import { useQuery } from '@tanstack/react-query';
import { logs } from '@repletoryreach/sdk-api';

export type LogStats = logs.LogStats;

export function useLogStats() {
  return useQuery({
    queryKey: ['admin', 'logs', 'stats'],
    queryFn: () => logs.stats()
  });
}

export function useLogQuery(opts: logs.LogQueryOptions) {
  return useQuery({
    queryKey: ['admin', 'logs', 'query', opts],
    queryFn: () => logs.query(opts)
  });
}
